<template>
  <div>
		<v-row class="mt-2" v-if="loadingGraphs">
      <v-col cols="12" sm="4" md="4" lg="4" v-for="i in 3" :key="i">
        <v-skeleton-loader type="sentences" class="mb-3"></v-skeleton-loader>
        <v-skeleton-loader type="image" class="mb-3"></v-skeleton-loader>
      </v-col>
    </v-row>
		<v-row class="mt-1 mb-0 px-1" v-else>
      <v-col cols="12" md="12">
        <v-row no-gutters align="center">
          <v-col cols="12" class="pt-0" md="4">
            <VueCtkDateTimePicker
              position="bottom"
              v-on:callback="changeDates"
              v-model="data_entrada"
              class="date-picker"
              locale="pt-BR"
              :no-header="true"
              :no-value-to-custom-elem="true"
              :overlay="true"
              :range="true"
              :formatted="'L'"
              :format="'YYYY-MM-DD'"
              color="#004A93"
              :dark="$vuetify.theme.dark"
              button-color="#004A93"
              :custom-shortcuts="labels"
              :no-button="true"
              :noClearButton="true"
              :auto-close="true"
              :loading="loadingSearch"
              :disabled="loadingSearch"
              :submit="retornoData(data_entrada)"
            >
              <v-btn class="px-2 ui-search_btn w-100" elevation="0" v-ripple="{ class: `success--text` }">
                <b class="text">
                  Período: {{ formatDateFront(de, 'LL')}} - {{formatDateFront(ate, 'LL') }}
                </b>
              </v-btn>
            </VueCtkDateTimePicker>
          </v-col>
        </v-row>
      </v-col>
      <v-col cols="12" sm="4" md="4" lg="4" v-if="grafico.tipo === 'bar' && !loadingGraphs">
        <v-card elevation="2" class="px-3 pt-3 pb-4">
          <div class="text-h2 text-center mb-2">
            {{ grafico.titulo}}
          </div>
          <bar-chart
            v-if="showGraph"
            :options="barChartOptions"
            :height="150"
            :data="barChartData"
          >
          </bar-chart>
        </v-card>
      </v-col>
			<!-- <v-col cols="12" sm="4" md="4" lg="4">
        <v-card elevation="2" class="px-3 pt-3 pb-4">
          <div class="text-h2 text-center mb-2">
            Por usuário responsável
          </div>
          <doughnut-chart
            :options="doughnutChartOption"
            :height="300"
            :data="doughnutChartDataUsuario">
          </doughnut-chart>
        </v-card>
      </v-col>
			<v-col cols="12" sm="4" md="4" lg="4">
        <v-card elevation="2" class="px-3 pt-3 pb-4">
          <div class="text-h2 text-center mb-2">
            Por usuário responsável
          </div>
          <div class="w-100">
            <v-row  class="sem_dados flex-column" no-gutters align-items="center" align="center" justify="center">
              <v-icon size="200" :color="this.$root.$vuetify.theme.isDark ? '#363636' : '#36363638'">running_with_errors</v-icon>
              <span>Dados insuficientes para gerar o gráfico</span>
            </v-row>
          </div>
        </v-card>
      </v-col> -->
		</v-row>
	</div>
</template>
<script>
import moment from 'moment'
import VueCtkDateTimePicker from 'vue-ctk-date-time-picker'
import 'vue-ctk-date-time-picker/dist/vue-ctk-date-time-picker.css'
import DoughnutChart from '@components/graficos/DoughnutChart.vue'
import BarChart from '@components/graficos/BarChart.vue'
export default {
  props: ['loadingSearch', 'grafico'],
  components: {
    VueCtkDateTimePicker,
    BarChart,
    DoughnutChart
  },
  watch: {
    grafico () {
      this.ajustaDados()
    }
  },
  data () {
    return {
      barChartOptions: {
        responsive: true,
        title: {
          display: true,
          position: 'left',
          fontSize: 14
        },
        scales: {
          y: {
            min: 0,
            suggestedMin: 0
          }
        }
      },
      barChartData: {
        labels: ['Gerados', 'Fechados'],
        datasets: []
      },
      showGraph: false,
      loadingGraphs: false,
      de: moment().subtract(90, 'days').format('YYYY-MM-DD'),
      ate: moment(new Date()).format('YYYY-MM-DD'),
      data_entrada: {
        start: moment().subtract(90, 'days').format('YYYY-MM-DD'),
        end: moment(new Date()).format('YYYY-MM-DD')
      },
      labels: [
        { key: 'thisDay', label: 'Hoje', value: 'day' },
        { key: 'last30Days', label: 'Últimos 30 dias', value: 30 },
        { key: 'thisMonth', label: 'Este mês', value: 'month' },
        { key: 'lastMonth', label: 'Mês passado', value: '-month' },
        { key: 'thisYear', label: 'Este ano', value: 'year' },
        { key: 'lastYear', label: 'Último ano', value: '-year' }
      ],
      loadingRelatorio: false,
      doughnutChartDataMotivo: null,
      doughnutChartOption: {
        responsive: true,
        cutoutPercentage: 50,
        maintainAspectRatio: false,
        legend: {
          position: 'top'
        },
        tooltips: {
          callbacks: {
            label: function (tooltipItem, data) {
              if (!data.money) return `${data.labels[tooltipItem.index]}: ${data.datasets[0].data[tooltipItem.index]}%`
              return `${data.labels[tooltipItem.index]}: ${data.datasets[0].totalFormatado}`
            }
          }
        }
      }
    }
  },
  methods: {
    generateColor () {
      const letters = '0123456789ABCDEF'
      let color = '#'
      for (let i = 0; i < 6; i++) {
        color += letters[Math.floor(Math.random() * 16)]
      }
      return color
    },
    async ajustaDados () {
      this.showGraph = false
      this.loadingGraphs = true
      await this.setBarChart()
      this.loadingGraphs = false
      this.showGraph = true
    },
    setBarChart () {
      let data = []
      this.grafico.values.map(value => {
        data.push({
          label: value.label,
          data: value.data,
          backgroundColor: value.backgroundColor
        })
      })

      this.barChartData.labels = this.grafico.labels
      this.barChartData.datasets = data
    },
    changeDates (dates) {
      this.de = dates.start
      this.ate = dates.end
    },
    formatDateFront (date, format = 'L') {
      return moment(date).format(format)
    },
    retornoData (datas) {
      if (datas.start !== this.de || datas.end !== this.ate) {
        if (this.data_entrada.end !== null) {
          this.de = this.data_entrada.start
          this.ate = this.data_entrada.end
          this.$emit('atualiza-grafico', datas)
        }
      }
    }
  },
  created () {
    this.ajustaDados()
  }
}
</script>
<style lang="scss" scoped>
@import "@scss/_variables.scss";
@import "@scss/_ui.scss";
.sem_dados {
  height: 300px;
  text-align: center;
}
</style>



// WEBPACK FOOTER //
// src/pages/relatorios/GraficosRelatorio.vue